import React from "react";
import { Link } from "react-router-dom";
import moment from "moment";
import * as FaIcons from "react-icons/fa";

const RegistrationFormCard = ({
  info: {
    _id,
    createdAt,
    status,
    age,
    firstName,
    lastName,
    pgRelationshipToStudent,
    permissionParentContact,
    registerForIntercession,
    pgFirstName,
    pgLastName,
    studentEmail,
    studentPrimaryPhone,
    learningCenterName,
  },
}) => {
  return (
    <Link to={`/registration-forms/${_id}`} className="interest-form-card">
      <div className="top">
        <div className="left">
          <div className="name">
            <h2>{firstName} {lastName}</h2>            
          </div>
          <FaIcons.FaUserCircle className="form-card-icon" />
        </div>
        {/* <div className="right">
          <h3>Age: {age}</h3>
        </div> */}
      </div>
      <div className="body">
         <div className="item">
          <h4>Age: </h4>
           <p>{age}</p>          
        </div>
        <div className="item">
          <h4>Submit Date: </h4>
          <p>{moment(createdAt).format("MM/DD/YYYY")}</p>
        </div>
        <div className="item">
          <h4>Status: </h4>
          <p>{status}</p>
        </div>
        <div className="item">
          <h4>Enrollment Type: </h4>
          <p>{registerForIntercession ? "Intersession" : "Regular"}</p>
        </div>
        <div className="item">
          <h4>Site: </h4>
          <p>{learningCenterName}</p>
        </div>
        <div className="item">
          <h4>Phone: </h4>
          <p>{studentPrimaryPhone}</p>
        </div>
        <div className="item">
          <h4>Email: </h4>
          <p>{studentEmail}</p>
        </div>
      </div>
    </Link>
  );
};

export default RegistrationFormCard;
